import React from "react";
import ProductScreen from "../../components/ProductScreen";

export default function Edge() {
  return (
    <ProductScreen
      heroImageSrc="/product-heroes/edge.png"
      eyebrow="Products / Edge"
      title="Edge"
      accent="#1d7f3b"
      description="Workspace for docs, incorporation, grants, schemes and requests."
      bullets={[
        "Document and workflow tools for operational teams.",
        "Manage incorporation, grants, and service requests.",
        "Keep every workspace task and approval in sync.",
      ]}
      features={[
        { title: "Workflows", text: "Standardize approvals and task handoffs across teams." },
        { title: "Documents", text: "Store key files alongside linked activities and records." },
        { title: "Permissions", text: "Control access with role-aware workspace governance." },
      ]}
      ctaLabel="Explore Edge"
      summaryKicker="Workspace Layer"
      summaryTitle="Organize service requests, documents, and approvals without losing flow."
      summaryText="Edge is designed to keep operational work calm and structured. It gives teams a place to manage the everyday motions around incorporation, documents, and requests."
    />
  );
}
